import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
import { volumes } from '../data/volumes';
export function VolumesSection() {
  return <section className="py-24 px-4 bg-[#F3F7FA]" data-id="element-354" data-mp="coiu4r4d9dov">
      <div className="max-w-6xl mx-auto" data-id="element-355" data-mp="cn7t2z2b2k1g">
        <div className="text-center mb-16" data-id="element-356" data-mp="cm4yoh5rxzgs">
          <h2 className="text-3xl md:text-4xl font-bold tracking-tight mb-4 text-[#0B2545]" data-id="element-357" data-mp="7qhe6f28luhm">
            THE COMPLETE <span className="text-[#0A7D79]" data-id="element-358" data-mp="3g6116wcbego8">6-IN-1</span> NURSING INSTRUCTOR{' '}
            <span className="bg-[#0A7D79] text-white px-2 box-decoration-clone" data-id="element-359" data-mp="3c4figud3n864">ATLAS</span> SYSTEM
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-8" data-id="element-360" data-mp="3pwlxue8fhb4i">
          {volumes.map((volume, index) => <motion.article key={volume.number} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          delay: index * 0.04,
          ease: [0.23, 1, 0.32, 1]
        }} className={`bg-white rounded-2xl border ${volume.popular ? 'border-2 border-[#0A7D79] shadow-lg shadow-[#0B2545]/10' : 'border-slate-200 shadow-sm shadow-[#0B2545]/5'} p-8 relative overflow-hidden flex flex-col h-full`} data-id="element-361" data-mp="3l2ri1lvy1gap" data-mpi={index}>
              {volume.popular && <div className="absolute top-7 right-[-44px] bg-[#0A7D79] text-white font-bold text-xs py-1 px-10 rotate-45 shadow whitespace-nowrap" data-id="element-362" data-mp="1qgmlrlsulxt1">
                  {volume.popularLabel ?? 'MOST POPULAR'}
                </div>}

              <div className="flex items-center gap-4 mb-6 pr-10" data-id="element-363" data-mp="20e10ngz4iej8">
                <span className="w-12 h-12 rounded-xl bg-[#0B2545] text-white font-extrabold text-2xl flex items-center justify-center shrink-0 border-b-4 border-[#0A7D79]" aria-hidden="true" data-id="element-364" data-mp="24gxcmou5rce7">
                  0{index + 1}
                </span>
                <div data-id="element-365" data-mp="1gqb325hwzxu6">
                  <div className="text-[#025B57] font-bold text-sm uppercase tracking-wider" data-id="element-366" data-mp="1gprieh0vqvcg">
                    {volume.number}
                  </div>
                  <h3 className="text-2xl font-bold tracking-tight leading-tight mt-1 text-[#0B2545]" data-id="element-367" data-mp="1priovo38v67d">
                    {volume.title}
                  </h3>
                </div>
              </div>

              <p className="text-[#025B57] font-semibold mb-6 border-l-4 border-[#0A7D79] pl-4" data-id="element-368" data-mp="x2tnrp26v0vm">
                {volume.subtitle}
              </p>

              {(volume.intro.length > 0 || volume.questions || volume.highlight) && <div className="mb-6 space-y-2" data-id="element-369" data-mp="16toizixexat7">
                  {volume.intro.map(paragraph => <p key={paragraph} className="text-slate-700 text-sm leading-relaxed" data-id="element-370" data-mp="1214wfwgqz5c9">
                      {paragraph}
                    </p>)}
                  {volume.questions && <ul className="grid sm:grid-cols-2 gap-2 pt-1" data-id="element-371" data-mp="9cptw9esyfht">
                      {volume.questions.map(question => <li key={question} className="text-[#0B2545] font-semibold text-sm bg-[#F3F7FA] border border-slate-200 rounded-lg px-3 py-2" data-id="element-372" data-mp="2kyro8f18mr9y">
                          {question}
                        </li>)}
                    </ul>}
                  {volume.highlight && <p className="text-[#0B2545] font-bold text-base bg-[#E4EEF4] border-l-4 border-[#0A7D79] rounded-lg px-4 py-3" data-id="element-373" data-mp="38q6v8l3ylwrj">
                      {volume.highlight}
                    </p>}
                  {volume.afterHighlight && <p className="text-slate-700 text-sm leading-relaxed" data-id="element-374" data-mp="2znxpe8jmyrkh">{volume.afterHighlight}</p>}
                </div>}

              <div data-id="element-375" data-mp="1oav81b9ppxz9">
                <div data-id="element-376" data-mp="1obde0zm6fqkd">
                  <p className="text-[#0B2545] font-semibold text-sm mb-3" data-id="element-377" data-mp="1obn1ogjr1lmw">{volume.bulletsIntro}</p>
                  <ul className={`mb-6 ${volume.bullets.length > 10 ? 'grid sm:grid-cols-2 gap-x-4 gap-y-3 content-start' : 'space-y-3'}`} data-id="element-378" data-mp="23l9yc4dow69f">
                    {volume.bullets.map(bullet => <li key={bullet} className="flex items-start gap-3" data-id="element-379" data-mp="2miunzdoa38v3">
                        <CheckCircle2 size={18} className="text-[#0A7D79] shrink-0 mt-0.5" data-id="element-380" data-mp="2mi1nuvjtrhlx" />
                        <span className="text-slate-700 text-sm" data-id="element-381" data-mp="2ii0zoj6xbs1o">{bullet}</span>
                      </li>)}
                  </ul>
                </div>

                {volume.secondaryBullets && <div data-id="element-382" data-mp="28lfthuj64aw9">
                    <p className="text-[#0B2545] font-semibold text-sm mb-3" data-id="element-383" data-mp="123iyfx6k6xzn">
                      {volume.secondaryBulletsIntro}
                    </p>
                    <ul className="mb-6 grid sm:grid-cols-2 gap-x-4 gap-y-3 content-start" data-id="element-384" data-mp="x2lilr90ug1b">
                      {volume.secondaryBullets.map(bullet => <li key={bullet} className="flex items-start gap-3" data-id="element-385" data-mp="ry9ob2bb4jul">
                          <CheckCircle2 size={18} className="text-[#0A7D79] shrink-0 mt-0.5" data-id="element-386" data-mp="wyfh4ltbcce9" />
                          <span className="text-slate-700 text-sm" data-id="element-387" data-mp="11om46h86foue">{bullet}</span>
                        </li>)}
                    </ul>
                  </div>}
              </div>

              {volume.sequence && <div className="mb-6" data-id="element-388" data-mp="1anzhjkzf8xke">
                  {volume.sequenceIntro && <p className="text-[#0B2545] font-semibold text-sm mb-2" data-id="element-389" data-mp="1fpyiko7ovie6">{volume.sequenceIntro}</p>}
                  <p className="text-[#0B2545] font-bold text-sm bg-[#E4EEF4] border border-slate-200 rounded-lg px-3 py-2" data-id="element-390" data-mp="1klnmt4unlngt">
                    {volume.sequence}
                  </p>
                </div>}

              <div className="bg-[#F3F7FA] border border-[#D0DEE8] border-l-4 border-l-[#0B2545] rounded-xl p-4 mt-auto" data-id="element-391" data-mp="3eef9hwqn5sem">
                <span className="text-[#0B2545] font-bold block mb-1" data-id="element-392" data-mp="39fu5rnc6kqlf">RESULT</span>
                {volume.resultLead && <p className="text-slate-700 text-sm" data-id="element-393" data-mp="3odcvarwon7tx">
                    {volume.resultLead}{' '}
                    <span className="font-semibold text-[#0B2545]" data-id="element-394" data-mp="3jcp70dzu953e">{volume.resultQuote}</span>
                  </p>}
                <p className="text-slate-700 text-sm" data-id="element-395" data-mp="15ivwzsbqpcm">{volume.result}</p>
                {volume.resultEmphasis && <p className="mt-2 text-xl font-extrabold tracking-tight text-[#0A7D79]" data-id="element-396" data-mp="axf79cjf8bys">
                    {volume.resultEmphasis}
                  </p>}
              </div>
            </motion.article>)}
        </div>
      </div>
    </section>;
}